import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import PropTypes from 'prop-types'
import Icon from '../Icons'
import { useTheme } from '../../theming/ThemeProvider'
import Identity from '../../utils/Identity'
import Txt from '../Txt'

export default function SelectableInput ({
  label, value, icon, rightIcon, placeholder,
  onPress, readonly, error, testID
}) {
  const { theme } = useTheme()
  const styles = useStyles(theme)

  return (
    <View>
      {Boolean(label) && (
        <Txt
          text={label}
          identity='body3Bold'
          style={styles.label}
          numberOfLines={1}
        />
      )}
      <TouchableOpacity
        onPress={onPress}
        style={styles.container}
        disabled={readonly}
        testID={testID}
        accessibilityLabel={testID}
      >
        <View
          style={[
            styles.inputContainer,
            error
              ? Identity.Borders(theme).Error
              : Identity.Borders(theme).Normal,
            readonly && { backgroundColor: theme.DISABLED_INPUT_COLOR }
          ]}
        >
          {Boolean(icon) && (
            <View style={styles.icon}>
              <Icon
                name={icon}
                height={16}
                width={16}
                fill={theme.ICON_COLOR}
              />
            </View>
          )}
          <View style={styles.input}>
            <Txt
              text={value || placeholder}
              color={value ? 'BUNKER' : 'SLATE_GRAY'}
              identity='body2'
              numberOfLines={1}
            />
          </View>
          {Boolean(rightIcon) && (
            <View style={styles.rightIcon}>
              {rightIcon}
            </View>
          )}
        </View>
        {Boolean(error) && (
          <Txt
            text={error}
            identity='body3'
            numberOfLines={1}
            style={styles.error}
          />
        )}
      </TouchableOpacity>
    </View>
  )
}
const useStyles = (theme) => StyleSheet.create({
  icon: {
    marginLeft: 15,
    padding: 0
  },
  rightIcon: {
    marginRight: 15,
    padding: 0
  },
  container: {
    paddingHorizontal: 0,
    height: 60
  },
  label: {
    marginBottom: 10
  },
  inputContainer: {
    height: 40,
    flexDirection: 'row',
    alignItems: 'center'
  },
  input: {
    flex: 1,
    marginHorizontal: 10,
    height: 40,
    justifyContent: 'center'
  },
  error: {
    margin: 0,
    marginTop: 3,
    color: theme.RED_ORANGE
  }
})

SelectableInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  rightIcon: PropTypes.any,
  onPress: PropTypes.func,
  readonly: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  testID: PropTypes.string
}

SelectableInput.defaultProps = {
  label: '',
  value: '',
  placeholder: '',
  icon: '',
  rightIcon: null,
  onPress: null,
  readonly: false,
  error: ''
}
